/**
 * QuickActions Component - Quick action buttons
 */

import React from 'react'
import { Card } from '../ui'
import { 
  Plus, 
  Upload, 
  Key, 
  FileText, 
  Users, 
  Settings,
  TrendingUp,
  ShieldCheck,
  Crown
} from 'lucide-react'

const QuickActions = ({
  actions = [],
  className = '',
  ...props
}) => {
  const defaultActions = [
    { 
      id: 'add-transaction', 
      label: 'Add Transaction', 
      icon: Plus, 
      color: 'bg-brand-soft text-brand',
      onClick: () => {} 
    },
    { 
      id: 'upload-document', 
      label: 'Upload Document', 
      icon: Upload, 
      color: 'bg-teal-soft text-teal',
      onClick: () => {} 
    },
    { 
      id: 'generate-token', 
      label: 'Generate Token', 
      icon: Key, 
      color: 'bg-gold-soft text-gold',
      onClick: () => {} 
    },
    { 
      id: 'view-investors', 
      label: 'Investor Portal', 
      icon: Crown, 
      color: 'bg-purple-soft text-brand',
      onClick: () => {} 
    },
  ]

  const items = actions.length > 0 ? actions : defaultActions

  return (
    <Card className={`p-5 ${className}`} {...props}>
      <h3 className="text-sm font-semibold text-ink mb-4">Quick Actions</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {items.map((action) => {
          const Icon = action.icon
          return (
            <button
              key={action.id}
              onClick={action.onClick}
              className="flex flex-col items-center gap-2 p-4 rounded-xl border border-neutral-200 hover:border-brand hover:shadow-md transition-all duration-200 group"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${action.color}`}>
                <Icon size={18} />
              </div>
              <span className="text-xs font-medium text-ink text-center">{action.label}</span>
            </button>
          )
        })}
      </div>
    </Card>
  )
}

QuickActions.displayName = 'QuickActions'

export default QuickActions